import {
  User_info
} from '@/library/lib.js'
import UserService from '@/services/User.js'
import { tokenMethods } from '@/library/lib'


function prepareUserFromApi(resp) {
  let data = resp.data,
    user_info = new User_info

  user_info.phone = data.phone
  user_info.email = data.email
  user_info.avatar = data.avatar
  user_info.layout = data.layout
  user_info.is_completed = data.is_completed || false
  user_info.name.value = data.username || ''

  for (let soc in user_info.socials) {
    if (data.socials[soc]) {
      user_info.socials[soc].link = data.socials[soc].link || ''
      user_info.socials[soc].view = data.socials[soc].view || ''
    }
  }

  return user_info
}


const state = {
  user_info: new User_info,
  token: localStorage.getItem('fotty_token')
}


const actions = {
  auth: function (state, obj = {
    cb: (param) => {
      return param
    },
    params: '/'
  }) {
    const requester = () => {
      UserService.get().then(resp => {
        state.commit('SET_USER_WITH_PREPARE', resp)
        this.dispatch('events/init')

        obj.cb()
      }).catch((error) => {
        if (error.response.status === 401) {
          tokenMethods.removeToken()
        }
        if (error.response.status === 502) {
          setTimeout(function () {
            requester()
          }, 1000)
        }
      })
    }
    if (localStorage.getItem('fotty_token')) {
      requester()
    } else {
      if (obj.params === '/') {
        obj.cb('/')
      } else {
        obj.cb('/auth/login/')
      }
    }
  },

  async save_user(state, obj) {
    let data_send = {
      'email': obj.email || '',
      'phone': obj.phone || '',
      'socials': {},
      'username': obj.name.value || ''
    }
    for (let i in obj.socials) {
      data_send.socials[i] = obj.socials[i].view
    }

    return await UserService.save(data_send)
  },

  async login(state, obj) {
    let _phone = obj.phone && obj.phone.replace(/\s/g, '').slice(-11) // костыль для обработки номера телефона при его подстановке из связки ключей
    let request = {
      phone: _phone || '',
      password: obj.password || ''
    }

    return await UserService.login(request)
  },

  async logout() {
    return await UserService.logout()
  },
}
const mutations = {
  SET_USER: (state, data) => {
    state.user_info = data
  },
  SET_USER_WITH_PREPARE: (state, data) => {
    let user_info = prepareUserFromApi(data)
    state.user_info = user_info
  },
  CLEAR_USER_INFO: (state) => {
    state.user_info = new User_info
  }
}
const getters = {
  get_user: state => {
    return state.user_info
  }
}


export default {
  state,
  mutations,
  getters,
  actions
}
